import { omit as _omit } from 'lodash';
import { arrayMoveImmutable as arrayMove } from 'array-move';

import types from './actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case types.CREATE_POOL: {
            return {
                ...state,
                [action.meta.id]: action.payload,
            };
        }
        case types.DELETE_POOL: {
            return _omit(state, action.meta.id);
        }
        case types.SORT_POOL: {
            if (state[action.meta.id]) {
                return {
                    ...state,
                    [action.meta.id]: arrayMove(
                        state[action.meta.id],
                        action.meta.info.oldIndex,
                        action.meta.info.newIndex,
                    ),
                };
            }
            return state;
        }
        default:
            return state;
    }
};
